module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('pattern-gallery', {
    staticClass: "gallery"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/into-icon.svg"),
      "width": "72",
      "height": "75"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "alt-font"
  }, [_vm._v("Design Tool")]), _vm._v(" "), _c('p', [_vm._v("\n        Welcome to " + _vm._s(_vm.brand) + "'s Design Tool. This handy tool allows you to build and customize your wall installation.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        To start, simply click on one of the templates to the left to begin designing.\n        Once in the tool, set the installation size, arrange colors, then save or email your work.\n        Have a change of heart? Return to this screen by clicking on ‘pattern gallery’ to select a new template.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        And if you need help at any time, click ‘contact us’ at the right of your screen.\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98daa1b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/Intro.vue
// module id = 571
// module chunks = 1